import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../config";
import axiosClient from "../../common/api/request";

export const getTaxSettings = createAsyncThunk(
  "get_tax_settings",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/taxes/`,
        { params },
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        // [CANA-589] the status lets the tab tell a 403 (no view_tax) apart
        // from a validation body.
        return rejectWithValue({
          ...error.response.data,
          status: error.response.status,
        });
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

// [CANA-591] the "Enable Taxes" master switch through the tax-scoped endpoint
// (backend CANA-590): GET needs view_tax, PATCH needs change_tax. It writes the
// same Setting.is_taxes_enabled column as settings/.
export const getTaxesEnabled = createAsyncThunk(
  "get_taxes_enabled",
  async (_, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/taxes/settings/`,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const patchTaxesEnabled = createAsyncThunk(
  "patch_taxes_enabled",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.patch(
        `${config.API_URL}/taxes/settings/`,
        params,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const postTaxSetting = createAsyncThunk(
  "post_tax_setting",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL}/taxes/`,
        params,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const patchTaxSetting = createAsyncThunk(
  "patch_tax_setting",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.patch(
        `${config.API_URL}/taxes/${params?.id}/`,
        params,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const deleteTaxSetting = createAsyncThunk(
  "delete_tax_setting",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.delete(
        `${config.API_URL}/taxes/${params.id}/`,
        params,
        config
      );
      return {
        data,
        id: params?.id,
      };
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
